// extracted by mini-css-extract-plugin
export var newsHeader = "news-module--news-header--CqSnr";
export var newsItemsEach = "news-module--news-items-each--yrr3V";
export var newsItemsRest = "news-module--news-items-rest--gth9R";
export var newsItemsWrapper = "news-module--news-items-wrapper--BA7ev";
export var newsLatest = "news-module--news-latest--rDHB9";
export var newsLatestImage = "news-module--news-latest-image--wkhQ4";
export var newsLatestTitle = "news-module--news-latest-title--XPvFd";
export var newsLatestWrapper = "news-module--news-latest-wrapper--m2i0C";